/** Tamaño de página por defecto en tablas del front. */
export const DEFAULT_TABLE_PAGE_SIZE = 10;

/** Opciones estándar de filas por página. */
export const TABLE_PAGE_SIZE_OPTIONS = [10, 20, 30, 50] as const;

export type TablePageSizeOption = (typeof TABLE_PAGE_SIZE_OPTIONS)[number];
